import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { PAGE } from 'src/app/routes';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private authService = inject(AuthService);
  private router = inject(Router);

  public async canActivate(): Promise<boolean> {
    const job = this.authService.isAuthenticated();
    const isAuthenticated = await job.runNoThrow();

    if (isAuthenticated) {
      return true;
    }
    this.router.navigate([`/${PAGE.LOADING}`]);
    return false;
  }
}
